export default __webpack_public_path__ + "static/media/limit_40.142d7db5.svg";